/// <reference path="./meevoTheming.section.base.ts" />

module Meevo.Plugins.MeevoTheming {
    "use strict";
    import BusinessInfoDataService = Meevo.Components.Common.BusinessInfoDataService;
    /**
    * Main Section of Holidays 
    */
    export class SmartCenterThemingSection extends MeevoThemingSectionBase {
        protected $http: angular.IHttpService;
        private bgColor1: string;
        private bgColor2: string;
        public saveFunction: any;
        public cancelFunction: any;

        private previousColors: {
            color1: string,
            color2: string,
            name: string
        }

        private respObj: any;
        constructor(sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            context: MeevoThemingContext,
            saveFunction: any,
            cancelFunction: any,
            sectionSecurityKey?: string,
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, context, saveFunction, cancelFunction, sectionSecurityKey);
            this.tenantId = identityService.current().tenantId;
            let uri = `/storagedrv/${this.tenantId}/styles/meevo.json`
            this.dataService.customMethodData(uri, 'GET', '', '')
                .then((response) => {
                    this.respObj = response.data;
                    let colors = this.respObj["colors"];

                    this.model = response.data;
                    this.activate();

                    this.previousColors = {
                        color1: colors["smartCenterColor1"],
                        color2: colors["smartCenterColor2"],
                        name: colors["smartCenterName"]
                    }


                    if (colors.smartCenterColor1) {
                        //this.bgColor1 = colors.smartCenterColor1;
                        //this.bgColor2 = colors.smartCenterColor2;
                        //this.selectedColor = colors.smartCenterName;


                    } else {

                        this.respObj.colors.smartCenterName = "Neutral DEFAULT";
                        this.respObj.colors.smartCenterColor1 = "#FFF";
                        this.respObj.colors.smartCenterColor2 = '#B9B3B4';

                        this.previousColors.color1 = '#FFF'
                        this.previousColors.color2 = '#B9B3B4'
                        this.previousColors.name = 'Neutral DEFAULT'
                    }

                }).catch((err: any) => { console.log("getThemeCss", err); });
        }

        activate(): void {
            super.activate();
            if (this.identityService.current().isSingleLocation ||
                this.identityService.current().centralOfficeId == this.identityService.current().locationId) {
                if (Model.Guard.isNothing(this.model.businessTypeDetail)) {
                    this.model.businessTypeDetail = {};
                    this.model.businessTypeDetail.id = this.identityService.businessTypeId;
                }
            }
        }

        public selectedColor = "Neutral DEFAULT";
        colors = [
            [//Neutral Colors
                {
                    name: 'Neutral DEFAULT',
                    stop1: '#FFF',
                    stop2: '#B9B3B4'
                },
                {
                    name: 'Neutral Gray Light',
                    stop1: '#FFF',
                    stop2: '#E6E7E8'
                },
                {
                    name: 'Neutral Earth',
                    stop1: '#FFF',
                    stop2: '#E5DFCC'
                },
                {
                    name: 'Neutral Earth Light',
                    stop1: '#FFF',
                    stop2: '#F4EFE4'
                },
            ],
            [//Standard Colors

                {
                    name: 'Yellow',
                    stop1: '#FFF',
                    stop2: '#F9F9D4',
                },
                {
                    name: 'Orange',
                    stop1: '#FFF',
                    stop2: '#E5C6AE'
                },
                {
                    name: 'Pink',
                    stop1: '#FFF',
                    stop2: '#EADAEA'
                },
                {
                    name: 'Purple',
                    stop1: '#FFF',
                    stop2: '#D8C7E5'
                },
                {
                    name: 'Blue',
                    stop1: '#FFF',
                    stop2: '#D4D6E8'
                },
                {
                    name: 'Green',
                    stop1: '#FFF',
                    stop2: '#DDEAD8'
                },
                {
                    name: 'Teal',
                    stop1: '#FFF',
                    stop2: '#D3E8EA',
                },
                {
                    name: 'Red',
                    stop1: '#FFF',
                    stop2: '#F5C9C5'
                },
                {
                    name: 'Magenta',
                    stop1: '#FFF',
                    stop2: '#EFCEE5',
                },
            ],
            [//Bold Colors

                {
                    name: 'Neutral Gray Bold',
                    stop1: '#929497',
                    stop2: '#404041'
                },
                {
                    name: 'Neutral Earth Bold',
                    stop1: '#FFF0DF',
                    stop2: '#C1B49A',
                },
                {
                    name: 'Orange Bold',
                    stop1: '#FFCA5F',
                    stop2: '#F78F1E'
                },
                {
                    name: 'Green Bold',
                    stop1: '#E0FFC8',
                    stop2: '#C5EC38',
                },
                {
                    name: 'Pink Bold',
                    stop1: '#F2E4F0',
                    stop2: '#DEBDDB',
                },
                {
                    name: 'Blue Bold',
                    stop1: '#E8EAF6',
                    stop2: '#BCC3F5'
                },
                {
                    name: 'Magenta Bold',
                    stop1: '#FFA6CB',
                    stop2: '#FF5273'
                },
                {
                    name: 'Red Bold',
                    stop1: '#FF8999',
                    stop2: '#D71F3D',
                },
                {
                    name: 'Purple Bold',
                    stop1: '#D8C7E5',
                    stop2: '#9175B5',
                },
                {
                    name: 'Teal Bold',
                    stop1: '#D8EDEE',
                    stop2: '#9FD5E9'
                }
            ],
        ];

        sections = [
            "Neutral Colors",
            "Standard Colors",
            "Bold Colors"
        ]

        transitionTime = '2s';

        get smartCenterColorsArray(): object {
            return this.colors;
        }


        setActive(bg, color1, color2, readOnly) {
            if (readOnly) {
                return;
            }

            this.respObj.colors["smartCenterName"] = bg;
            this.respObj.colors["smartCenterColor1"] = color1;
            this.respObj.colors["smartCenterColor2"] = color2;

            let preview = document.getElementById("smartcenter-preview");
            preview.style.setProperty('background', `radial-gradient(${color1},${color2})`, `important`);

            const head = document.getElementsByTagName('head')[0];
            const smartCenterElement = document.getElementById("smartCenterStyle")
            if (smartCenterElement) {
                smartCenterElement.remove();
            }

            const smartCenterColor = `.smart-center-designer-root .gridster{background: radial-gradient(${color1},${color2})}`
            const style = document.createElement('style');
            const css = `.smart-center-root, .smart-center-root.salon{background: radial-gradient(${color1},${color2}); transition: background 0s}` /*+ smartCenterColor*/
            style.type = 'text/css';
            style.id = "smartCenterStyle"
            style.appendChild(document.createTextNode(css));
            head.appendChild(style);



        }
        isActive(bg) {
            //return this.selectedColor === bg;
            return this.respObj.colors["smartCenterName"] === bg;
        }

        getPreviewbg() {
            //return { background: `radial-gradient(${this.bgColor1},${this.bgColor2})`}
            return { background: `radial-gradient(${this.respObj.colors.smartCenterColor1},${this.respObj.colors.smartCenterColor2})` }
        }


        public updateModel(): void {
            let businessTypeId = null;
            if (Model.Guard.isSomething(this.model.businessTypeDetail))
                businessTypeId = this.model.businessTypeDetail.id;
            else
                return;
            let uri = `/${Meevo.AppSettings.Default.API_ROOT}/${Meevo.AppSettings.Default.API_ENDPOINTS.meevoTheming}` + '/' + businessTypeId;
            if (Model.Guard.isSomething(this.model.businessTypeDetail)) {
                this.model.businessTypeId = this.model.businessTypeDetail.id;

                let parameters = {
                    businessTypeId: this.model.businessTypeId
                }
                this.dataService.customMethodData(uri, 'GET', '', '').then((results: any) => {
                    let temp = this.model.businessTypeDetail;
                    this.model = results.data;
                    this.model.businessTypeDetail = temp;
                });
            }
        }

        protected sendCss(): angular.IPromise<any> {

            let uri = `/storagedrv/${this.tenantId}/styles/meevo.json`
            let smartCenterbg = `.smart-center-root, .smart-center-root.salon{background: radial-gradient(${this.respObj.colors.smartCenterColor1},${this.respObj.colors.smartCenterColor2}); animation: scfadein 1s}`
            const smartCenterColor = `.smart-center-designer-root .gridster{background: radial-gradient(${this.respObj.colors.smartCenterColor1},${this.respObj.colors.smartCenterColor2})}`
            this.respObj.css["smartCenter"] = smartCenterbg /*+ smartCenterColor;*/
            let colors = this.respObj.colors;

            this.previousColors = {
                color1: colors["smartCenterColor1"],
                color2: colors["smartCenterColor2"],
                name: colors["smartCenterName"]
            }
            let data = this.respObj;
            return this.dataService.customMethodData(uri, 'POST', data, '')
                .then((response) => response.data).catch((err: any) => { console.log("getThemeCss"); });
        }
    }
}
